import React, { useState, useEffect } from 'react'

import { PatientDetails } from '../../components/common/patientDetails';

import {
    deleteAllPatientList,
    filterPatientsByPharmacistSign
} from '../../services/slices/supervisor/patientWithoutPharmacistSign';

import {
    ErrorMessage,
    SuccessMessage
} from '../../components/common/AllConfirmationMessages';

import { ErrorMessages } from '../../components/error/errorMessages';
import { PendingPharmacistSignRxData } from '../../components/common/dispenseRxData';

import { useSuperVisorSelector } from '../../services/selectors/allSuperVisorSelector';
import { fetchPatientListWithoutPharmacistSign } from '../../services/apis/supervisor/patientWithoutPharmacistSign';

import { useCustomStates } from '../../hooks/useCustomStates';
import { useAuthSelector } from '../../services/selectors/authSelector';
import { UpdatePharmacistSignature } from '../../services/apis/supervisor/updatePharmacistSign';

import InfiniteScroll from 'react-infinite-scroll-component';
import SearchBox from '../../components/common/searchBox';

import * as Icons from '../../assets/svg/icons';
import * as Common from '../../components/common';
import * as Hooks from '../../hooks';
import * as Loading from '../../components/common/loader'
import * as routeNames from '../../routes/routeName'

const PendingPharmacistSignatures = () => {

    const location = Hooks.useCustomLocation();

    const searchParams = new URLSearchParams(location.search);
    const pharmacistId = Number(searchParams.get('id'))

    const { pharmacyId } = useAuthSelector()
    const { PatientListWithoutPharmacistSignResponse } = useSuperVisorSelector()
    const patientList = PatientListWithoutPharmacistSignResponse?.data

    const { openIndex, setOpenIndex, setPharmacistSignature, pharmacistSignature,
        loading, setLoading, showPharmacistSignature, setShowPharmacistSignature,
        signatureErrors, setSignatureErrors, apiCallMade, setApiCallMade,

        consultation,
        setConsultation,

        selectedDoses,
        setSelectedDoses,
    } = useCustomStates()

    const [loadMore, setLoadMore] = useState(false)
    const [showToast, setShowToast] = useState({ successToast: false, errorToast: false })

    const dispatch = Hooks.useCustomDispatch();
    const navigate = Hooks.useCustomNavigate();

    const handleDropdownToggle = (index) => {
        setConsultation(null)
        if (openIndex === index) {
            setOpenIndex(null);
        } else {
            setOpenIndex(index);
        }

        setPharmacistSignature(null)
        setShowPharmacistSignature(false)
        setTimeout(() => {
            const nextPatientCard = document.getElementById(`patientCard-${index}`);
            if (nextPatientCard) {
                nextPatientCard.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }, 100)
        setSignatureErrors(prevState => ({ ...prevState, pharmacistSign: null }))
    }

    const onDropdownToggle = (index) => {
        handleDropdownToggle(index);
    }

    useEffect(() => {
        if (pharmacyId && pharmacistId) {
            setLoading(true)
            if (!apiCallMade) {
                dispatch(deleteAllPatientList())
                const params = {
                    pharmacy_id: pharmacyId,
                    pharmacist_id: pharmacistId,
                    page: 1,
                    setLoading: setLoading
                }
                dispatch(fetchPatientListWithoutPharmacistSign(params))
                setApiCallMade(true)
            }
        }
        return () => { }
    }, [])

    const fetchMoreData = () => {
        if (PatientListWithoutPharmacistSignResponse?.currentPage < PatientListWithoutPharmacistSignResponse?.totalPages) {
            setLoadMore(true)
            setLoading(false)
            const params = {
                pharmacy_id: pharmacyId,
                pharmacist_id: pharmacistId,
                page: PatientListWithoutPharmacistSignResponse?.currentPage + 1,
                setLoading: setLoading,
                setLoadMore: setLoadMore
            }
            dispatch(fetchPatientListWithoutPharmacistSign(params))
        }
    }

    const handleUpdatePharmacistSignature = (id, index, patientData) => {

        const flexiDeliveryIDs = patientData?.patients_win_rx_data_delivered
            ?.filter(patient => patient?.is_din_matched?.status === 1 && patient?.flexi_delivery)
            ?.map(patient => patient?.id);

        if (!pharmacistSignature) {
            setSignatureErrors(prevState => ({ ...prevState, pharmacistSign: '1px solid red' }));
        }
        else {
            const requestedData = {
                pharmacy_id: pharmacyId,
                signature: pharmacistSignature,
                patient_id: id,
                setShowToast: setShowToast,
                dispatch: dispatch,
                setLoading: setLoading,
                pharmacist_id: pharmacistId,
                consultation: consultation,
                flexi_rx_refill_id: flexiDeliveryIDs
            }

            dispatch(filterPatientsByPharmacistSign(id))
            setOpenIndex(null);
            setPharmacistSignature(null)
            setShowPharmacistSignature(false)
            dispatch(UpdatePharmacistSignature(requestedData))

            setSignatureErrors(prevState => ({ ...prevState, pharmacistSign: null }));
            setTimeout(() => {
                const nextIndex = index;
                const nextPatientCard = document.getElementById(`patientCard-${nextIndex}`);
                if (nextPatientCard) {
                    nextPatientCard.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            }, 100);
            setShowToast(prevState => ({ ...prevState, successToast: true }));

            setTimeout(() => {
                setShowToast(prevState => ({ ...prevState, successToast: false }))
            }, 2000);
        }
    }

    const handleScrollSign = (index) => {
        setTimeout(() => {
            const nextPatientCard = document.getElementById(`signature-${index}`);
            if (nextPatientCard) {

                nextPatientCard.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }, 100)
    }

    return (<React.Fragment>

        {patientList?.length > 0 &&
            <InfiniteScroll
                dataLength={patientList?.length}
                next={fetchMoreData}
                hasMore={PatientListWithoutPharmacistSignResponse?.currentPage <= PatientListWithoutPharmacistSignResponse?.totalPages}
            />
        }

        <div className="app-wrapper flex justify-center">
            <div className="app-screen no-shades w-full h-full overflow-x-hidden">

                <div className="relative p-4" >
                    <div className="card bg-white p-4 rounded-lg shadow-sm">
                        <div className="flex items-center justify-between gap-3">
                            <div>
                                <Common.TopBar pharmacyId={pharmacyId} />
                            </div>
                            <div className='flex items-center justify-center btnnn pt-4'
                                onClick={() => navigate(`${routeNames.DASHBOARD_PHARMACY}`)} >
                                <Icons.HomeIcon />
                            </div>
                        </div>
                    </div>

                    <div className="title-row my-2" >
                        <h1 className="text-xl font-bold">Pending Signatures</h1>
                    </div>

                    <div className="flex gap-3 mb-3">
                        <SearchBox pharmacyId={pharmacyId} />
                    </div>

                    <div className="routes-list">
                        {(PatientListWithoutPharmacistSignResponse?.loading && loading) ?
                            <div className='flex justify-center h-96'>
                                <Loading.LoadingView />
                            </div> :

                            PatientListWithoutPharmacistSignResponse?.error !== null ?
                                <div className='flex  justify-center pb-4 mb-4'>
                                    <ErrorMessages error={'Oops! Got an issue while fetching Data.Please try again!'} />
                                </div> :

                                (patientList?.length === 0 && !PatientListWithoutPharmacistSignResponse?.loading) ?
                                    <p className='flex  justify-center pb-4 pt-3 h-96'>
                                        No more pending signatures for today.</p>
                                    :
                                    patientList?.map((data, index) => (
                                        <React.Fragment key={index}>
                                            {data?.patients_win_rx_data_delivered?.length === 0 || data?.patients_win_rx_data_delivered === null ? null :
                                                <div className="card bg-white p-4 rounded-lg shadow-sm mb-3" id={`patientCard-${index}`}>

                                                    <PatientDetails
                                                        data={data}
                                                        totalRxData={data?.patients_win_rx_data_delivered?.length}
                                                        index={index}
                                                        patientImg={data.profile_image}
                                                        openIndex={openIndex}
                                                        onDropdownToggle={onDropdownToggle}
                                                    />

                                                    {openIndex === index && <>

                                                        <PendingPharmacistSignRxData
                                                            selectedDoses={selectedDoses}
                                                            setSelectedDoses={setSelectedDoses}
                                                            rxData={data?.patients_win_rx_data_delivered} patientData={data} />

                                                        <div className='mb-2'>
                                                            <Common.DeliveryConsultationDropdown consultation={consultation}
                                                                setConsultation={setConsultation} />
                                                        </div>

                                                        <div className='' onClick={() => handleScrollSign(index)} id={`signature-${index}`}>
                                                            <Common.PharmacistSignature
                                                                pharmacistSignature={pharmacistSignature}
                                                                setPharmacistSignature={setPharmacistSignature}
                                                                showPharmacistSignature={showPharmacistSignature}
                                                                setShowPharmacistSignature={setShowPharmacistSignature}
                                                                signatureErrors={signatureErrors}
                                                                setSignatureErrors={setSignatureErrors}
                                                                signingAsName={searchParams.get('name') || undefined}
                                                            />
                                                        </div>

                                                        <button onClick={() => handleUpdatePharmacistSignature(data.id, index, data)} className="px-4 flex-1 py-2 bg-green-500 text-white rounded-md w-full">
                                                            Continue
                                                        </button>
                                                    </>}
                                                </div>}
                                        </React.Fragment>))}
                    </div>
                </div>

                {loadMore && <div className='flex mb-2'>
                    <div className="loaderss"></div>
                </div>}

                {showToast.successToast && <SuccessMessage message='Signature Updated Successfully' setShowToast={() => setShowToast(prevState => ({ ...prevState, successToast: false }))} />}
                {showToast.errorToast && <ErrorMessage message='Oops! Got an issue while updating sign.please try again.' setShowToast={() => setShowToast(prevState => ({ ...prevState, errorToast: false }))} />}

            </div>
        </div>
    </React.Fragment>
    )
}

export default PendingPharmacistSignatures